<script setup lang="ts">
import { LineupModel } from '@collector/desktop-feature-lineups'
import { runLoader, useConfirmModal } from '@collector/shared-ui'
import { Participant } from '@collector/sportsapi-types'
import { useEvent } from '@desktop/views/Relation/composables'
import BaseLineupsModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/BaseLineupsModal/BaseLineupsModal.vue'
import InvalidAssignedPlayersConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/InvalidAssignedPlayersConfirmModal.vue'
import NoCoachConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/NoCoachConfirmModal.vue'
import {
  UpdateLineupsFn,
  useLineupConfig,
} from '@desktop/views/Relation/Sports/composables'

interface Props {
  participant: Participant
}
const props = defineProps<Props>()

// composables
const { openModalForConfirm } = useConfirmModal()
const { config } = useLineupConfig()
const { event } = useEvent()

// methods
async function confirmUpdateLineup(
  lineup: LineupModel,
  _initialLineup: LineupModel,
  updateLineups: UpdateLineupsFn,
): Promise<void> {
  const startingLineupMax =
    config.value.positions.startingLineup.maxCount ?? Infinity
  const startingLineupCount = lineup.startingLineup.length
  const coachCount = lineup.coach.length

  if (startingLineupCount > 0 && startingLineupCount !== startingLineupMax)
    await openModalForConfirm<typeof InvalidAssignedPlayersConfirmModal>(
      InvalidAssignedPlayersConfirmModal,
      { maxPlayersInFirstLineup: startingLineupMax },
    )
  if (coachCount === 0) await openModalForConfirm(NoCoachConfirmModal)

  await runLoader(updateLineups(event.value.id, props.participant.id, lineup))
}
</script>

<template>
  <BaseLineupsModal
    :participant
    :confirmUpdateLineup
  />
</template>
